import React from "react";
import { useDispatch } from "react-redux";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Slider from "@material-ui/core/Slider";
import { Palette } from "../AppConfig";
import BSL_ControlContainer from "./BSL_ControlContainer";
import { Tooltip } from "@material-ui/core";
import { BaseURL } from "../components/Common";
import BSL_TextInput from "./BSL_TextInput";

const useStyles = makeStyles((theme) => ({
    slider: {
        // overflow: "hidden"
        // width: '77%',
        // marginLeft: '20px',
    },
    slider_mark: {
        color: Palette.Control.PaleBlue,
        font: (theme.brand.LYSAGHT ? "10px " : "12px ") + theme.typography.fontFamily,
        lineHeight: "2.2",
    },
    slider_mark_disabled: {
        color: "aaaaaa",
        fontStyle: "italic",
        font: (theme.brand.LYSAGHT ? "10px " : "12px ") + theme.typography.fontFamily,
        lineHeight: "2.2",
    },
    mark: {
        backgroundColor: "#6B8799",
        width: "1px",
        height: "8px",
        marginTop: "6px",
    },
    thumb: {
        background: "url(" + BaseURL("images/thumb.svg") + ")",
        width: "28px",
        height: "28px",
        boxShadow: "none",
        marginTop: "-12px",
        marginLeft: "-13px",
        backgroundSize: "28px 28px",
        boxShadow: "none !important",
        borderRadius: "0%",
    },
    rail: {
        background: Palette.Control.FieldersDarkBlue,
        opacity: 0.8,
    },
    label: {
        padding: "0px 7px 0 px 0px",
        margin: "7px 7px",
        font: (theme.brand.LYSAGHT ? "14px " : "14px ") + theme.typography.fontFamily,
        color: Palette.Control.FieldersDarkBlue,
        minWidth: "40px",
        whiteSpace: "nowrap",
    },
    label_disabled: {
        padding: "0px 7px 0 px 0px",
        margin: "7px 7px",
        font: (theme.brand.LYSAGHT ? "14px " : "14px ") + theme.typography.fontFamily,
        color: "aaaaaa",
        fontStyle: "italic",
        minWidth: "40px",
        whiteSpace: "nowrap",
    },
}));

// function BSL_ThumbComponent(props) {
//     return (
//         <span className=>
//             <span className="bar" />
//             <span className="bar" />
//             <span className="bar" />
//         </span>
//     );
// }

const BSL_ToolTip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: Palette.Control.FieldersDarkBlue,
        color: "white",
    },
    arrow: {
        color: Palette.Control.FieldersDarkBlue,
    },
}))(Tooltip);

function ValueLabelComponent(props) {
    const { children, open, value } = props;

    return (
        <BSL_ToolTip arrow open={open} enterTouchDelay={0} placement="top" title={value}>
            {children}
        </BSL_ToolTip>
    );
}

export default function BSL_Slider(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [value, setValue] = React.useState(props.value);

    function valuetext(value) {
        return `${value}°C`;
    }

    let textFieldStyle = props?.editableTextStyle ? props?.editableTextStyle : {};

    return (
        <BSL_ControlContainer {...props}>
            <div style={{ display: "flex", flexDirection: "row" }}>
                <Slider
                    classes={{
                        root: classes.slider,
                        mark: classes.mark,
                        markActive: classes.mark,
                        markLabel: props.disabled ? classes.slider_mark_disabled : classes.slider_mark,
                        markLabelActive: props.disabled ? classes.slider_mark_disabled : classes.slider_mark,
                        rail: classes.rail,
                        thumb: classes.thumb,
                    }}
                    disabled={props?.disabled}
                    ValueLabelComponent={ValueLabelComponent}
                    valueLabelFormat={props.valueLabelFormat ? props.valueLabelFormat : undefined}
                    // ThumbComponent={BSL_ThumbComponent}
                    getAriaValueText={valuetext}
                    track={false}
                    value={value ? value : props.value}
                    min={props?.min ? Number(props?.min) : 0}
                    max={props?.max ? Number(props?.max) : 0}
                    marks={props?.marks}
                    step={props?.step ? props?.step : 1}
                    onChange={(e, val) => {
                        setValue(val);
                        if (props.onChangeStep) props.onChangeStep(e, val);
                    }}
                    onChangeCommitted={(e, val) => {
                        setValue(null);
                        if (props.onChange) props.onChange(e, val);
                    }}
                    valueLabelDisplay="auto"
                    // onChange={(e, value) => { let rounded_val = Math.round(value / 50) * 50; this.props.updateAreaSpecification(areaIndex, BASIC_SPECS_SECTIONS.SHAPE, "Length", rounded_val); this.updateSVG(); }}
                />
                {props?.editableTextField && !props?.customTextField && (
                    <BSL_TextInput
                        value={value ? value : props.value}
                        tight
                        style={{
                            ...textFieldStyle,
                            flex: "none",
                            minWidth: "80px",
                            maxWidth: "80px",
                            padding: "0px",
                            margin: "1px",
                            marginLeft: "16px",
                        }}
                        onChange={(val) => {
                            setValue(null);

                            let new_val = Number(val);
                            let min = props?.min ? Number(props?.min) : 0;
                            if (new_val < min) new_val = Number(min);
                            if (props?.max && new_val > Number(props?.max)) new_val = Number(props?.max);

                            props.onChange(null, new_val);
                        }}
                        onBlur={(val) => {
                            setValue(null);

                            let new_val = Number(val);
                            let min = props?.min ? Number(props?.min) : 0;
                            if (new_val < min) new_val = Number(min);
                            if (props?.max && new_val > Number(props?.max)) new_val = Number(props?.max);

                            props.onChange(null, new_val);
                        }}
                        InputProps={{ style: { borderWidth: "0px" } }}
                        inputPropsStyle={{ borderWidth: "0px" }}
                        endAdornment={props?.endAdornment ? props.endAdornment : props?.suffix}
                        // onBlur={(val) => updateMarkup(key, "DisplayName", val)}
                    />
                )}
                {!props?.editableTextField && !props?.customTextField && (
                    <div className={props.disabled ? classes.label_disabled : classes.label}>
                        {props.valueLabelFormat
                            ? props.valueLabelFormat(value ? value : props.value)
                            : value
                            ? parseFloat(value.toFixed(2))
                            : parseFloat(props.value.toFixed(2))}
                        {props?.suffix ? props?.suffix : ""}
                    </div>
                )}
                {props?.customTextField && props.customTextField(value ? value : props.value)}
            </div>
        </BSL_ControlContainer>
    );
}
